"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayPlan = void 0;
const types_1 = require("../main/types");
class DayPlan extends types_1.DayPlanType {
    constructor(userId, date) {
        super(userId);
        this.date = date;
    }
}
exports.DayPlan = DayPlan;
DayPlan.converter = {
    toFirestore(data) {
        return {
            userId: data.userId,
            date: data.date,
            progress: data.progress,
            highestCorrectStreak: data.highestCorrectStreak,
            finishedModuleCount: data.finishedModuleCount,
            inprogressModuleCount: data.inprogressModuleCount,
            todoModuleCount: data.todoModuleCount,
            estimatedCompletionTime: data.estimatedCompletionTime,
            actualStudyTime: data.actualStudyTime,
            acquisitionTarget: data.acquisitionTarget,
            acquisitionProgress: data.acquisitionProgress,
            reviewTarget: data.reviewTarget,
            reviewProgress: data.reviewProgress
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const id = snapshot.id;
        const userId = documentData.userId;
        const date = documentData.date;
        const data = new DayPlan(userId, date);
        data.id = id;
        data.progress = documentData.progress;
        data.highestCorrectStreak = documentData.highestCorrectStreak;
        data.finishedModuleCount = documentData.finishedModuleCount;
        data.inprogressModuleCount = documentData.inprogressModuleCount;
        data.todoModuleCount = documentData.todoModuleCount;
        data.estimatedCompletionTime = documentData.estimatedCompletionTime;
        data.actualStudyTime = documentData.actualStudyTime;
        data.acquisitionTarget = documentData.acquisitionTarget;
        data.acquisitionProgress = documentData.acquisitionProgress;
        data.reviewTarget = documentData.reviewTarget;
        data.reviewProgress = documentData.reviewProgress;
        return data;
    }
};
